import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import "./discussforums.css";

export default function DiscourseForums() {
  return (
    <div className="coming-soon-container">
      <h1 className="coming-soon-title">Coming Soon</h1>
      <p className="coming-soon-text">
        We're working hard to bring something amazing!
      </p>
      <div className="social-icons">
        <a
          href="https://www.facebook.com/S3NSoftware"
          target="_blank"
          className="social-icon facebook"
        >
          <FaFacebook fontSize="small" />
        </a>
        <a
          href="https://www.instagram.com/S3NSoftware"
          target="_blank"
          className="social-icon instagram"
        >
          <FaInstagram fontSize="small" />
        </a>
        <a
          href="https://twitter.com/s3n_sw"
          target="_blank"
          className="social-icon twitter"
        >
          <FaTwitter fontSize="small" />
        </a>
      </div>
    </div>
  );
}
